"use strict";
/* globals module */
/**
 * @module commerceProductSettingsClient
 * @description  Product Settings Client provides an easy way to consume  Product Settings REST API end-points. In order to obtain needed routes `productSettingsClient` uses `productSettingsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../httpApi");
var _1 = require(".././");
var CommerceProductSettingsClient = /** @class */ (function () {
    function CommerceProductSettingsClient(productSettingsRoute, apiClient) {
        this.productSettingsRoute = productSettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceProductSettingsClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `baasicProductSettingsRouteService`.
         * @method
         * @example productSettingsClient.routeDefinition.get().expand(expandObject);
         **/
        get: function () {
            return this.productSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the product settings.
     * @method
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example productSettingsClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    CommerceProductSettingsClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update product settings action has been performed; this action updates product settings. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `productSettingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(productSettings);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the update product settings action has been performed.
     * @example // productSettings is a resource previously fetched using get action.
                    productSettings.allowArchive = true;
                    productSettingsClient.update(productSettings)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    CommerceProductSettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.update(data));
    };
    var _a, _b;
    CommerceProductSettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CommerceProductSettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CommerceProductSettingsRoute !== "undefined" && _1.CommerceProductSettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceProductSettingsClient);
    return CommerceProductSettingsClient;
}());
exports.CommerceProductSettingsClient = CommerceProductSettingsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 
